import { useHistory } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { useAccount } from './../../contexts/Account';
import eventBus, { eventBusValues } from './../../eventBus';
import { ReactComponent as PaperPlusIcon } from './../../icons/paper-plus.svg';
import { ReactComponent as CalendarCheckIcon } from './../../icons/calendar-check.svg';
import { ReactComponent as BooksIcon } from './../../icons/books.svg';
import Footer from './Footer';
import BoardTile from '../../components/BoardTile';
import BoardroomActivity from '../../components/BoardroomActivity';
import TopSection from '../../components/Company/TopSection';
import BoardStats from './BoardStats';

const tileTitleStyle = {
  fontSize: { xxs: 16, xs: 20 },
  lineHeight: { xxs: '20px', xs: '26px' },
  fontWeight: '600',
  marginBottom: { xxs: '7px', xs: '14px' },
  textAlign: 'left',
};

const tileDescriptionStyle = {
  fontSize: 12,
  lineHeight: '18px',
  fontWeight: '400',
  color: '#4D586F',
  textAlign: 'left',
};

export default function CompanyDashboardV2() {
  const { accountDetails } = useAccount();
  const history = useHistory();

  function seeOpportunity() {
    eventBus.dispatch(eventBusValues.triggerCompanyDrawerAction, {
      company: accountDetails,
    });
  }

  return (
    <Box sx={{ p: { xxs: 2, xs: 4 }, backgroundColor: '#F4F8FF' }}>
      <TopSection />
      <Grid container spacing={2} sx={{ mt: 0, mb: 2 }}>
        <Grid item xxs={12} md={6}>
          <BoardStats />
        </Grid>
        <Grid item xxs={12} md={6}>
          <BoardroomActivity company={accountDetails} showEmptyState />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <BoardTile
          image={<BooksIcon style={{ width: 90, height: 90 }} />}
          onClick={() => seeOpportunity(accountDetails?.id)}
        >
          <Typography sx={tileTitleStyle}>Background Materials</Typography>
          <Typography sx={tileDescriptionStyle}>
            Enable your advisors to learn more about you, your goals, benefits
            for board members, and anything else related to your advisory board.
          </Typography>
        </BoardTile>
        <BoardTile
          image={<CalendarCheckIcon style={{ width: 60, height: 60 }} />}
          onClick={() => history.push(`/advisors`)}
        >
          <Typography sx={tileTitleStyle}>Board Members</Typography>
          <Typography sx={tileDescriptionStyle}>
            View current advisors, invite your contacts, search the advisor
            directory and see how easy it is to grow your advisory board.
          </Typography>
        </BoardTile>

        <BoardTile
          image={<CalendarCheckIcon style={{ width: 60, height: 60 }} />}
          onClick={() => history.push(`/board_activity`)}
        >
          <Typography sx={tileTitleStyle}>Boardroom Activity</Typography>
          <Typography sx={tileDescriptionStyle}>
            View the full log of boardroom activity, advisory board
            announcements and favorite ideas shared in the boardroom.
          </Typography>
        </BoardTile>

        <BoardTile
          image={<PaperPlusIcon style={{ width: 60, height: 60 }} />}
          onClick={() => {}}
          id="get-assistance"
        >
          <Typography sx={tileTitleStyle}>Get Assistance</Typography>
          <Typography sx={tileDescriptionStyle}>
            Launch live chat to get assistance and answer any questions related
            to your advisory board.
          </Typography>
        </BoardTile>
      </Grid>
      <Footer />
    </Box>
  );
}
